import { defineComponent as t, openBlock as n, createBlock as l, unref as a, mergeProps as p, withCtx as s, createElementVNode as c } from "vue";
import { RevIcon as i } from "@ds/components/Icon";
const f = /* @__PURE__ */ t({
  name: "IconCross",
  __name: "IconCross",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const r = o;
    return (m, e) => (n(), l(a(i), p(r, { "view-box": "0 0 24 24" }), {
      default: s(() => [...e[0] || (e[0] = [
        c("path", {
          "fill-rule": "evenodd",
          d: "M3.47 3.47a.75.75 0 0 1 1.06 0L12 10.94l7.47-7.47a.75.75 0 1 1 1.06 1.06L13.06 12l7.47 7.47a.75.75 0 1 1-1.06 1.06L12 13.06l-7.47 7.47a.75.75 0 0 1-1.06-1.06L10.94 12 3.47 4.53a.75.75 0 0 1 0-1.06",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
